import { gql, useMutation } from "@apollo/client";
import { useCallback } from "react";

const DeleteAll1on1PlanFutureClassRoomsMutation = gql`
  mutation deleteAll1on1PlanFutureClassRoomsSilently($planId: String!) {
    deleteAll1on1PlanFutureClassRoomsSilently(planId: $planId)
  }
`;

export function useDeleteAll1on1PlanFutureClassRooms() {
  const [mutate, { loading }] = useMutation(
    DeleteAll1on1PlanFutureClassRoomsMutation,
  );

  const deleteAll = useCallback(
    async (planId: string) => {
      await mutate({ variables: { planId } });
    },
    [mutate],
  );

  return { deleteAll, loading };
}
